import { handleAccordionHeadClick } from "../lib/common/accordion.js";

const $accordionHead = $('.accordion-head');

$accordionHead.click(handleAccordionHeadClick);
